module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"tickethoss-web","short_name":"tickethoss","start_url":"/","background_color":"#00001F","theme_color":"#00001F","display":"minimal-ui","icon":"src/images/ticketHostLogo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0632bc1d51ded85e9cce806a6853f718"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
